import {
  brandedProductId,
  standOutProductId,
} from 'src/app/shared/constants/productIds';
import {
  PREMIUM_ASIA_UPSELL_WIDGET_SHOWN_STORAGE_KEY,
  PREMIUM_UPSELL_WIDGET_SHOWN_STORAGE_KEY,
} from 'src/app/shared/constants/storage';
import type { CartItem } from 'src/graphql/generated';

const hasPremiumUpsellWidgetBeenShown = () =>
  sessionStorage.getItem(PREMIUM_UPSELL_WIDGET_SHOWN_STORAGE_KEY) === 'true';

const hasPremiumAsiaUpsellWidgetBeenShown = () =>
  sessionStorage.getItem(PREMIUM_ASIA_UPSELL_WIDGET_SHOWN_STORAGE_KEY) ===
  'true';

const hasProductInCart = ({
  productIds,
  cart,
}: {
  productIds: string;
  cart?: CartItem[];
}) => {
  if (!cart) return false;

  // Determine if the productIds can be currently found in cart
  return Boolean(cart.find((item) => productIds.includes(item.product.id)));
};

export const getShouldShowPremiumUpsell = ({ cart }: { cart?: CartItem[] }) =>
  hasPremiumUpsellWidgetBeenShown() ||
  hasProductInCart({
    cart,
    productIds: standOutProductId,
  });

export const getShouldShowPremiumAsiaUpsell = ({
  cart,
}: {
  cart?: CartItem[];
}) =>
  hasPremiumAsiaUpsellWidgetBeenShown() ||
  hasProductInCart({
    cart,
    productIds: brandedProductId,
  });
